<template>
  <div
    :title="beneficiaryName"
    :class="[
      'beneficiary-card cursor-pointer',
      isSelected ? 'card_selected' : ''
    ]"
  >
    <span
      v-show="!isSelected"
      class="pt-1 success_hv"
    />
    <span
      v-show="isSelected && allowDeselection"
      class="pt-1 remove_item_card"
    ><font-awesome-icon
      :icon="['far', 'times-circle']"
      class="success_hv"
    /></span>
    <div
      :style="logoSize"
      class="beneficiary-logo"
    >
      <img
        :src="imagePath"
        alt="Card image cap"
      >
    </div>
    <div class="mt-2 px-0 d-block">
      <p class="beneficiary-name px-2 text-center">
        {{ beneficiaryName }}
      </p>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
    components: {FontAwesomeIcon},
    props: {
        beneficiaryName: {
            type: String,
            default: ""
        },

        allowDeselection: {
            type: Boolean,
            default: true
        },

        imagePath: {
          type: String,
          default: ""
        },

        isSelected: {
          type: Boolean,
          default: false
        },
        /**
         * Can be square or list
         */
        cardStyle: {
            type: String,
            default: "square"
        },

        imageSize: {
            type: String,
            default: "200px"
        }
    },
    computed: {
        logoSize() {
            return { width: this.imageSize, height: this.imageSize };
        }
    }
};
</script>
<style scoped>
.table-cell {
	display: table-cell !important;
}

@media (hover: hover) {
	.beneficiary-card:hover .success_hv {
		display: block;
		-webkit-transition: all 0.5s;
	}
}

.success_hv {
	position: absolute;
	right: 5px;
	top: 2px;
	display: none;
	z-index: 1;
	font-size: 1.5em;
	color: #f57c33;
}

.remove_item_card {
	position: relative;
	left: 200px;
	top: 5px;
	z-index: 1;
}
.remove_item_card:before {
	color: #f57c33;
	padding: 0px 4px;
	font-size: 1.5em;
}

.cursor-pointer {
    cursor: pointer !important;
}
.beneficiary-card:hover .beneficiary-logo {
    -webkit-box-shadow: 0px 0px 20px 3px rgba(0,0,0,0.06);
    -moz-box-shadow: 0px 0px 20px 3px rgba(0,0,0,0.06);
    box-shadow: 0px 0px 20px 3px rgba(0,0,0,0.06);
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
}

.beneficiary-logo {
    position: relative;
    -webkit-box-shadow: 0px 0px 0px 1.5px rgba(235,235,235,1);
    -moz-box-shadow: 0px 0px 0px 1.5px rgba(235,235,235,1);
    box-shadow: 0px 0px 0px 1.5px rgba(235,235,235,1);
    border-radius: 20px;
    overflow: hidden;
}

.beneficiary-logo img {
    position: absolute;
    top: 0;
    bottom: 0;
    left:0;
    margin: auto;
    width: 100%;
    -o-object-fit: cover;
    object-fit: cover;
}

.beneficiary-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
